import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Modal, Textinput, Flex, Typo, theme } from '../../../ui';

const NativeInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${theme.colors.NEU_200};
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: ${theme.colors.NEU_PRIMARY};
  background: ${theme.colors.NEU_0};

  &:focus {
    outline: none;
    border-color: ${theme.colors.PRIMARY};
  }
`;

const FieldLabel = styled(Typo.SmallText)`
  color: ${theme.colors.NEU_600};
  font-weight: 500;
  margin-bottom: 4px;
`;

const AddQuizModal = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [questionCount, setQuestionCount] = useState('10');
  const [timeLimit, setTimeLimit] = useState('30');

  const handleAccept = async () => {
    await onSubmit({
      name,
      questionCount: parseInt(questionCount, 10) || 10,
      timeLimit: `${timeLimit}`,
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('classroom.addQuiz', 'Add Quiz / Assessment')}
      width='480px'
      showActions
      onAccept={handleAccept}
      acceptLabel={t('globals.add', 'Add')}
      acceptIsDisabled={!name.trim()}
    >
      <Flex direction='column' gap='16'>
        <Textinput
          label={t('classroom.quizName', 'Name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder='e.g. Chapter 5 — Final Quiz'
        />
        <Flex direction='column' gap='4'>
          <FieldLabel>{t('classroom.questionCount', 'Number of Questions')}</FieldLabel>
          <NativeInput
            type='number'
            min='1'
            max='100'
            value={questionCount}
            onChange={(e) => setQuestionCount(e.target.value)}
          />
        </Flex>
        <Flex direction='column' gap='4'>
          <FieldLabel>{t('classroom.timeLimit', 'Time Limit (minutes)')}</FieldLabel>
          <NativeInput
            type='number'
            min='1'
            max='180'
            value={timeLimit}
            onChange={(e) => setTimeLimit(e.target.value)}
          />
        </Flex>
      </Flex>
    </Modal>
  );
};

export default AddQuizModal;
